module.exports = __webpack_public_path__ + "96c0d16176226d20e7a27ece35874b14.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/tick-dky.png
// module id = ./assets/images/footer/tick-dky.png
// module chunks = 0